import React from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'antd';

import { DOMAIN_SELECTOR_OPTIONS } from 'constants/signin';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as CloseIcon } from 'assets/bosta-icons/Close.svg';

import './DomainSelectorModal.less';

const DomainSelectorModal = ({ close, onCardClick = () => {}, ...props }) => {
  const intl = useIntl();

  return (
    <Modal
      className="br-domain-selector-modal"
      {...props}
      footer={null}
      width={null}
      title={null}
      onCancel={close}
    >
      <div className="br-domain-selector-modal__title">
        <span className="display-xs">
          {intl.formatMessage({ id: 'sign_in.domain_selector_title' })}
        </span>
        <BRButton
          type="treitary-gray"
          suffixIcon={<CloseIcon />}
          onClick={close}
        />
      </div>
      <div className="br-domain-selector-modal__content">
        {DOMAIN_SELECTOR_OPTIONS.map(({ icon, title, value, example }) => (
          <div
            key={value}
            className="br-domain-selector-modal__content-card"
            onClick={() => {
              onCardClick(value);
              close();
            }}
          >
            <span className="br-domain-selector-modal__content-card__icon">
              {icon}
            </span>
            <span className="br-domain-selector-modal__content-card__text">
              <span className="body-medium">{title}</span>
              {example && (
                <span className="br-domain-select__example subheading">
                  {example}
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default DomainSelectorModal;
